/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import { DisplayHtmlContent, Heading } from 'sarsaparilla';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { CAPE_LOOKOUT_PERMIT_ID } from '../../utils/utils';

function PermitType({ reservation, permit, children }) {
    const permitType =
        permit.permit_types_list?.find((types) => types.id === reservation.permit_type) ??
        {};
    const customDescription =
        permit.id === CAPE_LOOKOUT_PERMIT_ID ? permitType.description : null;
    return (
        <div className="permit-vehicle-wrap mt-5">
            <Heading headingLevel={2} appearance="h5">
                Permit Type
            </Heading>
            {
                <DisplayHtmlContent
                    html={customDescription ?? get(permitType, `description`)}
                />
            }
            {children}
        </div>
    );
}

PermitType.propTypes = {
    permit: PropTypes.object.isRequired,
    reservation: PropTypes.object.isRequired,
};

export default PermitType;
